import React from "react";
import { uiConfig, auth } from "../../firebase.js";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import "./signup.css";

const Signup = () => {
  return (
    <div className="signup">
      <div className="signup__container">
        <div className="signup__logo">
          <h1 style={{ color: "#ffbf00" }}>MedVault</h1>
        </div>
        <div className="signup__content">
          <h3>Sign in</h3>
          <hr />
          <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={auth} />
        </div>
      </div>
    </div>
  );
};

export default Signup;
